(() => {
  'use strict';

  const enhanceAboutPage = (root = document) => {
    /* Give the page one meaningful H1 without changing reusable section settings. */
    const heroHeading = root.querySelector('.about-section1 .section-title h2');
    const existingMainH1 = document.querySelector('main h1');

    if (heroHeading && !existingMainH1) {
      const h1 = document.createElement('h1');
      [...heroHeading.attributes].forEach((attribute) => {
        h1.setAttribute(attribute.name, attribute.value);
      });
      h1.innerHTML = heroHeading.innerHTML;
      heroHeading.replaceWith(h1);
    }

    /* The first story section had no visible heading in its saved settings. */
    const firstStory = root.querySelector(
      '#shopify-section-image_with_text_9YVqCA .about-content'
    );

    if (
      firstStory &&
      !firstStory.querySelector('h2, h3, .zy-about-injected-title')
    ) {
      const eyebrow = document.createElement('span');
      eyebrow.className = 'zy-about-eyebrow';
      eyebrow.textContent = 'The Zyvira Beginning';

      const title = document.createElement('h2');
      title.className = 'zy-about-injected-title';
      title.textContent = 'Jewellery for Every Version of You';

      firstStory.prepend(title);
      firstStory.prepend(eyebrow);
    }

    /* Correct duplicated video headings saved in the section settings. */
    const videoHeadings = [
      {
        selector: '#shopify-section-sh_video_zpPhnX .sp-video-heading',
        text: 'Jewellery with Heart, Soul & Art'
      },
      {
        selector: '#shopify-section-sh_video_UUKqRH .sp-video-heading',
        text: 'Every Detail, Made to Feel Special'
      }
    ];

    videoHeadings.forEach(({ selector, text }) => {
      const heading = root.querySelector(selector);
      if (heading) heading.textContent = text;
    });

    /* Add useful fallback alt text only where the saved image has no alt. */
    const imageAltBySection = [
      ['#shopify-section-about_us_banner_93gpK7 img', 'Zyvira jewellery brand story'],
      ['#shopify-section-image_with_text_9YVqCA img', 'The story behind Zyvira jewellery'],
      ['#shopify-section-image_with_text_VLKwG8 img', 'The meaning and inspiration behind Zyvira'],
      ['#shopify-section-image_with_text_y3zDKd img', 'Zyvira jewellery for the modern woman'],
      ['#shopify-section-image_with_text_EEz8pn img', 'Zyvira jewellery packaging made to create joy'],
      ['#shopify-section-image_with_text_mfWwen img', 'Zyvira quality and customer trust'],
      ['#shopify-section-image_with_text_pDzh3h img', 'Affordable luxury jewellery by Zyvira in India']
    ];

    imageAltBySection.forEach(([selector, alt]) => {
      const image = root.querySelector(selector);
      if (image && !image.getAttribute('alt')) image.setAttribute('alt', alt);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAboutPage());
  } else {
    enhanceAboutPage();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enhanceAboutPage(event.target || document);
  });
})();
